<app-card-list [columns]="columns" [cards]="cards"></app-card-list>
